import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { HostProductCodeEntity } from "src/app/features/HostProductCode/types/HostProductCodeEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { acquirerProviderSelectConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const HostProductCodeSearchForm: FC<SearchFormProps<HostProductCodeEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("hostProductCodeCreateForm.acquirer")} name="acquirer">
                <SelectDynamic name="acquirer" label={t("hostProductCodeCreateForm.acquirer")} fieldConfig={acquirerProviderSelectConfig} />
            </Form.Item>
            <Form.Item label={t("hostProductCodeCreateForm.internalCode")} name="internalCode">
                <TextInput name="internalCode" />
            </Form.Item>
        </SearchForm>
    );
};
